<template>
    <KTeaserCard
        :as="NuxtLink"
        :to="`/${item.full_slug}`"
        :text="text"
        variant="editorial"
        class="featured-article-card"
        @click="capture('related_article_clicked', {
            placement: 'featured-articles',
            target_slug: item.full_slug,
        })"
    >
        <template #media>
            <KFrame ratio="89 / 40">
                <NuxtImg
                    :src="image"
                    :alt="alt"
                    width="712"
                    height="320"
                    fit="cover"
                    format="auto"
                    loading="lazy"
                    sizes="xs:100vw sm:712px md:433px lg:300px"
                />
            </KFrame>
        </template>
        <template #title>
            <span v-html="title" />
        </template>
    </KTeaserCard>
</template>

<script setup>
import { KFrame, KTeaserCard } from '@vemedia/karibu'
import { resolveComponent } from 'vue'
import renderHighlightedText from '~/helpers/renderHighlightedText'
import './featured-article-card.scss'

const { item } = defineProps(['item'])

const { capture } = useTracking()

const NuxtLink = resolveComponent('NuxtLink')

const title = renderHighlightedText(item.content.title)
const text = item.content.subtitle
const image = item.content.image?.filename
const alt = item.content.image?.alt
</script>
